<template>
  <v-container fluid>
    <v-row class="mt-16 noimprimir"> </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-row>
            <v-col cols="12" md="4" style="margin-bottom:-30px;">
              <v-alert dense text color="green"
                >Suma de totales: {{ formateaMoneda(totalesCobranza.STotales) }}</v-alert
              >
            </v-col>
            <v-col cols="12" md="4" style="margin-bottom:-30px;">
              <v-alert dense text color="green"
                >Suma de abonos hechos: {{ formateaMoneda(totalesCobranza.SAbonos) }}</v-alert
              >
            </v-col>
            <v-col cols="12" md="4" style="margin-bottom:-30px;">
              <v-alert dense text color="green"
                >Suma de saldo por pagar: {{ formateaMoneda(totalesCobranza.SDeuda) }}</v-alert
              >
            </v-col>
          </v-row>

          <v-card-title>
            Resumen Cobranza
            <v-spacer></v-spacer>
            <v-col class="noimprimir" sm="6" lg="2" cols="12" md="6">
              <v-text-field
                dense
                @input="
                  consultaResumenCobranza();
                  consultaTotalesCobranza();
                "
                v-model="aliasBusqueda"
                label="Alias"
                hide-details
                clearable
                outlined
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col class="noimprimir" sm="6" lg="2" md="6" cols="12">
              <v-text-field
                dense
                @input="
                  consultaResumenCobranza();
                  consultaTotalesCobranza();
                "
                v-model="nombreBusqueda"
                label="Nombre"
                hide-details
                clearable
                outlined
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col class="noimprimir" sm="6" md="6" lg="2" cols="12">
              <v-text-field
                dense
                @input="
                  consultaResumenCobranza();
                  consultaTotalesCobranza();
                "
                v-model="telefonoBusqueda"
                label="Teléfono"
                hide-details
                clearable
                outlined
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col class="noimprimir" sm="6" md="6" lg="2" cols="12">
              <v-select
                dense
                item-text="NOMBRE"
                item-value="ID"
                @input="
                  consultaResumenCobranza();
                  consultaTotalesCobranza();
                "
                v-model="sucursalBusqueda"
                :items="sucursalesList"
                label="Sucursal"
                hide-details
                clearable
                outlined
                autocomplete="new"
              ></v-select>
            </v-col>
            <v-col class="noimprimir" sm="6" md="6" lg="2" cols="12">
              <v-select
                style="margin-bottom:-26px !important;"
                dense
                :items="[5, 10, 15, 50, 80]"
                label="Elementos por página"
                v-model="regPag"
                outlined
                @input="consultaResumenCobranza()"
              ></v-select>
            </v-col>
          </v-card-title>
          <v-data-table
            :loading="tableLoading"
            loading-text="Cargando... por favor espere."
            :headers="headers"
            :items="resumenCob"
            :items-per-page="regPag"
            hide-default-footer
          >
            <template #item.sumaTotal="{ item }">
              <div style="font-weight:bold;">{{ formateaMoneda(item.SUMATOTAL) }}</div>
            </template>
            <template #item.totalAbonos="{ item }">
              <div style="font-weight:bold;">{{ formateaMoneda(item.TOTALABONOS) }}</div>
            </template>
            <template #item.deudaTotal="{ item }">
              <div style="font-weight:bold;">{{ formateaMoneda(item.DEUDATOTAL) }}</div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <div class="noimprimir">
          <v-pagination
            @input="consultaResumenCobranza(0)"
            v-model="pag"
            :length="paginasAbonosEnvios"
          ></v-pagination>
        </div>
      </v-col>
      <v-col cols="3"></v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import _ from "lodash";
export default {
  data: () => ({
    tableLoading: false,
    aliasBusqueda: "",
    nombreBusqueda: "",
    telefonoBusqueda: "",
    sucursalBusqueda: "",
    regPag: 80,
    pag: 1,
    headers: [
      // {
      //   text: "ID",
      //   align: "ID",
      //   sortable: false,
      //   value: "ID"
      // },
      // {
      //   text: "Alias",
      //   align: "center",
      //   sortable: false,
      //   value: "ALIAS"
      // },
      {
        text: "Nombre completo",
        align: "center",
        sortable: false,
        value: "NOMBRE_COMPLETO"
      },
      // {
      //   text: "Teléfono",
      //   align: "center",
      //   sortable: false,
      //   value: "TELEFONO"
      // },
      // {
      //   text: "Sucursal",
      //   align: "center",
      //   sortable: false,
      //   value: "SUCURSAL"
      // },
      {
        text: "Suma total",
        align: "center",
        sortable: false,
        value: "sumaTotal"
      },
      {
        text: "Total abonos",
        align: "center",
        sortable: false,
        value: "totalAbonos"
      },
      {
        text: "Deuda total",
        align: "center",
        sortable: false,
        value: "deudaTotal"
      }
    ]
  }),
  async mounted() {
    this.tableLoading = true;
    await this.getSucursales();
    await this.consultaResumenCobranza();
    await this.consultaTotalesCobranza();
    this.tableLoading = false;
  },
  async beforeDestroy() {
    await this.destroyResumenDeCobranza();
  },
  methods: {
    ...mapActions("abonosEnvios", [
      "getResumenCobranza",
      "getTotalesCobranza",
      "destroyResumenDeCobranza"
    ]),
    ...mapActions("sucursales", ["getSucursales"]),
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    consultaTotalesCobranza: _.debounce(async function() {
      await this.getTotalesCobranza({
        alias: this.aliasChecked,
        nombre: this.nombreChecked,
        telefono: this.telefonoChecked,
        sucursal: this.sucursalChecked
      });
    }, 400),
    consultaResumenCobranza: _.debounce(async function(pagi = 1) {
      this.tableLoading = true;
      if (pagi == 1) {
        this.pag = 1;
      }
      await this.getResumenCobranza({
        regPag: this.regPag,
        pag: this.pag,
        alias: this.aliasChecked,
        nombre: this.nombreChecked,
        telefono: this.telefonoChecked,
        sucursal: this.sucursalChecked
      });
      this.tableLoading = false;
    }, 400)
  },
  computed: {
    ...mapState("abonosEnvios", {
      resumenCob: state => state.resumenCobranza,
      paginasAbonosEnvios: state => state.paginasAbonosEnvios,
      totalesCobranza: state => state.totalesCobranza
    }),
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    aliasChecked() {
      return this.aliasBusqueda == "" || this.aliasBusqueda == null
        ? ""
        : `&alias=${this.aliasBusqueda}`;
    },
    nombreChecked() {
      return this.nombreBusqueda == "" || this.nombreBusqueda == null
        ? ""
        : `&nombre=${this.nombreBusqueda}`;
    },
    telefonoChecked() {
      return this.telefonoBusqueda == "" || this.telefonoBusqueda == null
        ? ""
        : `&telefono=${this.telefonoBusqueda}`;
    },
    sucursalChecked() {
      return this.sucursalBusqueda == "" || this.sucursalBusqueda == null
        ? ""
        : `&sucursal=${this.sucursalBusqueda}`;
    }
  }
};
</script>
<style lang="css" scoped>
.noimprimir {
  display: block;
}
@media print {
  .noimprimir {
    display: none;
  }
}
</style>
